import { render, staticRenderFns } from "./MessagesNew.vue?vue&type=template&id=5c3c09a3&"
import script from "./MessagesNew.vue?vue&type=script&lang=js&"
export * from "./MessagesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports